var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 4H6C3.79086 4 2 5.79086 2 8V17C2 19.2091 3.79086 21 6 21H18C20.2091 21 22 19.2091 22 17V8C22 5.79086 20.2091 4 18 4ZM6 5.59H18C19.0657 5.59204 20.0025 6.29663 20.3 7.32L12.76 12.91C12.5534 13.112 12.2732 13.221 11.9843 13.2115C11.6955 13.2021 11.423 13.0751 11.23 12.86L3.72 7.33C4.01175 6.30973 4.9389 5.60216 6 5.59ZM3.59 17C3.59 18.331 4.66899 19.41 6 19.41H18C19.3271 19.4045 20.4 18.3271 20.4 17V8.97L13.6 13.97C13.1654 14.3746 12.5938 14.5997 12 14.6C11.3827 14.5902 10.7911 14.3514 10.34 13.93L3.59 8.93V17Z",
    fill: "#626262"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.6c2d4308.svg";
export { ForwardRef as ReactComponent };